import React from 'react';

import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();

export default function PublicationEthics() {
   
    return (
        <div className="row justify-content-md-center">
            <div className="col-md-12">
                <div className="row content-space-around" >
                    <div className="col-md-12 col-sm-12 body-container ">
                        <div className="row justify-content-md-center ">
                            <div className="col-md-10">
                                <div className="subbody-coming-soon ">
                        <div >
                            <div className="subbody-content aims " >
                            <h3>Publication Ethics and Malpractice Statement</h3>
                                <p>The Journal of Business, Ethics and Society (JBES) is committed to maintaining the highest standards of publication ethics and integrity, in full compliance with the principles and guidelines established by the Committee on Publication Ethics (COPE). The journal upholds fairness, transparency, and accountability throughout its publication process.</p>
                                <hr/>
                                <h4>1. Ethical Guidelines for Authors</h4>
                                <ul>
                                <li>Authors must submit only original, unpublished work that is not under consideration elsewhere.</li>
                                <li>All sources used in the research must be properly cited and acknowledged.</li>
                                <li>Any form of plagiarism, data fabrication, or falsification is strictly prohibited.</li>
                                <li>Authors are required to disclose any financial or non-financial conflicts of interest that may influence their research outcomes.</li>
                                <li>The views and conclusions expressed in published articles are solely those of the authors and do not necessarily represent the position of the editorial board or the publisher.</li>
                                <li>To ensure originality, all manuscripts are screened for plagiarism and AI-generated content. The acceptable overall similarity index for research articles is not more than 10% (excluding tables, figures, and references).</li>
                                </ul>
                                <h4>2. Ethical Guidelines for Editors</h4>
                                <ul>
                               <li> Editors are responsible for ensuring the integrity and quality of the peer-review and publication process.</li>
                               <li>Editorial decisions are based solely on the manuscript’s academic merit, originality, and relevance, without bias or discrimination.</li>
                               <li>Editors must maintain confidentiality regarding submitted manuscripts and must not use unpublished material for their own research.</li>
                               <li>The editorial board adheres strictly to COPE’s Code of Conduct and Best Practice Guidelines for Journal Editors.</li>
                               <li>Editors must not use generative AI or AI-assisted technologies (such as ChatGPT) in evaluating, editing, or making decisions on manuscripts.</li>
                                </ul>


                                <h4>3. Ethical Guidelines for Reviewers</h4>
                                <ul>
                                <li>Reviewers are expected to evaluate manuscripts objectively, fairly, and within the agreed timeframe.</li>
                                <li>They must maintain confidentiality and must not use any information obtained during the review process for personal or professional advantage.</li>
                                <li>Reviewers should disclose any conflicts of interest that could affect their judgment.</li>
                                <li>The use of generative AI or AI-assisted tools during the peer-review process is not permitted.</li>
                                </ul>

                                <h4>4. Plagiarism and Misconduct Policy</h4>
                                <p>JBES maintains a zero-tolerance policy for plagiarism, data manipulation, and unethical research practices. All manuscripts are subjected to similarity checks and ethical screening before acceptance. Any proven cases of misconduct will result in rejection or retraction of the article, and appropriate action will be taken following COPE’s guidelines.</p>

                               <h4>5. Compliance and Accountability</h4>
                               <p>The Journal of Business, Ethics and Society is fully guided by COPE’s ethical framework. The journal’s editorial board ensures that all parties involved—authors, reviewers, and editors—adhere to these ethical principles to preserve academic integrity and trust in scholarly communication.</p>
                            </div>
                        </div>
                       
                    </div>
                  
                </div>
                </div>
                </div>
                </div>
            </div>
        </div>
    );
}

